import vars from '../../vars';
import Plyr from 'plyr/dist/plyr.polyfilled.js';
 
$('.js-audio-player').each(function() {
	const player = new Plyr(this, {
		invertTime: false
	});
});


// WEBPACK FOOTER //
// ./src/js/pages/longrid/longrid-audio.js